import { render, staticRenderFns } from "./EmployeeFrist.vue?vue&type=template&id=95f7ada8&"
import script from "./EmployeeFrist.vue?vue&type=script&lang=js&"
export * from "./EmployeeFrist.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeFrist.vue?vue&type=style&index=0&id=95f7ada8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports